import { EnumDatiTitolareTipologia } from '@framework/api-client/api/inquiries-compile/schemas/enumDatiTitolareTipologia.ts';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { useTranslation } from 'react-i18next';
import { PersonRole } from './getPersonalDataItems.ts';

export interface IPersonRoleTagProps {
  role: PersonRole;
  /** Tipologia del soggetto, usata quando il ruolo è `Other` */
  subjectType?: EnumDatiTitolareTipologia;
}

/**
 * Tag che indica il ruolo del soggetto nella richiesta
 * (Titolare, Legale Rappresentante, Procuratore, altri soggetti)
 */
export function PersonRoleTag(props: Readonly<IPersonRoleTagProps>) {
  const { t } = useTranslation();

  const labels: Record<PersonRole, string> = {
    [PersonRole.Applicant]: t('submission-summary.tag-titolare', 'Titolare'),
    [PersonRole.LegalRepresentative]: t(
      'submission-summary.tag-legale-rappresentante',
      'Legale Rappresentante',
    ),
    [PersonRole.Attorney]: t(
      'submission-summary.tag-procuratore',
      'Procuratore',
    ),
    [PersonRole.Other]: t(
      'submission-summary.tag-altro-soggetto',
      'Altro soggetto',
    ),
  };

  const subjectLabels: Record<EnumDatiTitolareTipologia, string> = {
    [EnumDatiTitolareTipologia.TITOLARE]: t(
      'submission-summary.tag-titolare',
      'Titolare',
    ),
    [EnumDatiTitolareTipologia.SUPPORTO]: t(
      'submission-summary.tag-supporto',
      'Supporto',
    ),
  };

  const label =
    (props.subjectType ? subjectLabels[props.subjectType] : undefined) ??
    labels[props.role];

  return <StyledTag color="blue">{label}</StyledTag>;
}
